import React from 'react';

const Favourites = (props) => {
  return <div>Favourites Page</div>;
};

export default Favourites;
